import { css } from 'styled-components';

export const selectionMarker = css`
  .selection-marker {
    background-color: #e8ebed;
  }
`;
